/**
 * toggleClass
 * @param {Array} configs - 設定の配列 [{selector, className}, ...]
 */
/**
 * toggleClass
 * @param configs Array of config objects
 * @param configs[].selector       - イベントを設定する要素のセレクタ
 * @param configs[].className      - 付与/削除するクラス名（デフォルト: 'js-toggle'）
 * @param configs[].targetSelector - クラスを付ける対象（省略時はクリックした要素自身）
 */
export function toggleClass(configs) {
	configs.forEach(({ selector, className = 'js-toggle', targetSelector }) => {
		const elements = document.querySelectorAll(selector);
		if (elements.length === 0) return;

		elements.forEach((element) => {
			element.addEventListener('click', (ev) => {
				const target = targetSelector
					? element.querySelector(targetSelector) || document.querySelector(targetSelector)
					: ev.currentTarget;

				if (target) {
					target.classList.toggle(className);
				}
			});
		});
	});
}
